module.exports = __webpack_public_path__ + "img/PL00258.561fe38b.png";